import { FieldWrapperComponent } from "../field-wrapper.component";

export class FieldWrapperKeyboardTabEvent {

    constructor(protected _$event: KeyboardEvent, protected _fieldWrapper: FieldWrapperComponent) {

    }

    get $event(): KeyboardEvent {
        return this._$event;
    }

    get fieldWrapper(): FieldWrapperComponent {
        return this._fieldWrapper;
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/field-wrapper/events/field-wrapper-keyboard-tab-event.ts